import { groupByOverallTypeAndSortDocuments } from '@containers/scalable-document-list/document-grouping';
import {
    DocumentImage,
    DocumentImageGroup
} from '@containers/scalable-document-list/document-image';
import { ScrollContainer } from '@styles/container-styles';
import * as React from 'react';
import {
    DocumentsContainer,
    DocumentWrapper,
    RowContainer
} from './styles';

interface Props {
    className?: string;
    classes?: {
        row?: string;
    };
    /**
     * Documents to display
     */
    documents: DocumentImage[];
    /**
     * Callback to gather and sort the documents into groups
     * @param documents
     */
    groupAndSortDocuments?: (documents: DocumentImage[]) => DocumentImageGroup[];
    /**
     * Render callback to display the document
     * @param document
     */
    renderDocument?: (document: DocumentImage) => React.ReactNode;
    /**
     * Render callback to display the extra content below each group of documents
     * @param documentGroup
     */
    renderRowContent?: (documentGroup: DocumentImageGroup) => React.ReactNode;
}

/**
 * Scrollable responsive document list, tries to expand to container.
 *
 * Each row wraps its children (ie. documents of the same type)
 *
 * Each row can have an extra render slot (eg. for a checkbox)
 */
class ScalableDocumentList extends React.PureComponent<Props> {
    static defaultProps = {
        groupAndSortDocuments: groupByOverallTypeAndSortDocuments,
        renderDocument: document => <img src={document.dataUrl}/>
    };

    render() {
        const groupedAndSorted = this.props.groupAndSortDocuments!(this.props.documents);
        const asRows = groupedAndSorted.map(row => (
            <RowContainer key={row.type}
                          className={this.props.classes?.row}>
                <DocumentsContainer>
                    {
                        row.documents.map(document => (
                            <DocumentWrapper key={document.type + document.id}>
                                { this.props.renderDocument?.(document) }
                            </DocumentWrapper>
                        ))
                    }
                </DocumentsContainer>
                {
                    this.props.renderRowContent?.(row)
                }
            </RowContainer>
        ));

        return (
            <ScrollContainer className={this.props.className}>
                {asRows}
            </ScrollContainer>
        );
    }
}

export default ScalableDocumentList;



// WEBPACK FOOTER //
// ./src/containers/scalable-document-list/index.tsx